import { FelaCSS, FelaCSSWithCustomSelectors, colors } from '@bridebook/ui';

interface IStyles {
  wrapper?: FelaCSSWithCustomSelectors;
}

const styles = (): IStyles => {
  const disabledInteraction: FelaCSS = {
    cursor: 'default',
    pointerEvents: 'none',
  };

  return {
    wrapper: {
      alignItems: 'center',

      '> .pagination': {
        display: 'flex',
        alignItems: 'center',
        listStyleType: 'none',
        userSelect: 'none',

        '> li': {
          marginLeft: '5px',

          ':nth-of-type(2)': {
            marginLeft: '0',
          },

          ':first-of-type': {
            marginLeft: '0',
          },

          ':last-of-type': {
            marginRight: '0',
          },

          '> a': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '40px',
            height: '40px',
            fontDefault: 16,
            lineHeight: '20px',
            color: colors.space,
            borderRadius: '100%',

            ':hover': {
              backgroundColor: colors.space08,
              textDecoration: 'none',
            },

            ':focus': {
              textDecoration: 'none',
            },

            ':active': {
              textDecoration: 'none',
            },
          },
        },

        '> li.disabled': {
          ...disabledInteraction,
          backgroundColor: 'transparent',
        },

        '> li.selected': {
          ...disabledInteraction,

          '> a': {
            color: colors.white,
            backgroundColor: colors.space,
          },
        },

        '> li.break': {
          ...disabledInteraction,
        },
      },
    },
  };
};

export default styles;
